// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import TerceraPopupErrorScreen from '@front/templates/TerceraPopupErrorScreen.html';
import { Control } from '../elements/Control';
import { popupErrorHandler } from '@shared/utils/AppHandlers';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
import { BOTTOM_WINDOWS_MARGIN, TOP_WINDOWS_MARGIN } from '../UtilsClasses/SizeConstants';
export class PopupErrorScreen extends Control {
    constructor() {
        super(...arguments);
        this.isShowed = false;
        this.owner = null;
    }
    getType() {
        return ScreensNames.PopupErrorScreen;
    }
    // TODO. Ugly. Refactor.
    Show(owner, errText, headerText, isShowHeader = true, isDown = null, additionalStyle = '', withBorder = true) {
        if (typeof this.el !== 'object') {
            this.el = document.getElementById(this.el);
            void this.render(this.el);
        }
        void this.set({
            additionalStyle,
            headerText: headerText !== null && headerText !== void 0 ? headerText : 'Error',
            headerVisible: isShowHeader,
            errorText: errText,
            visible: true
        });
        this.isShowed = true;
        this.owner = owner;
        const popupScreen = this.find('.popup-error-screen');
        if (isNullOrUndefined(popupScreen))
            return;
        const ownerRectangle = owner.getAbsoluteRectangle();
        const errRect = PopupErrorScreen.getErrorAbsoluteRectangle(ownerRectangle, this.get('width'), popupScreen.offsetHeight);
        isDown = isDown || ownerRectangle.Y > errRect.Y;
        const top = errRect.Top() + (isDown ? -8 : 8); /* 128997 */
        void this.set({
            left: errRect.Left(),
            top,
            elementStyle: isDown ? 'js-win-popupError-bottom' : 'js-win-popupError-top',
            withBorder
        });
    }
    // TODO. Ugly.
    static getErrorAbsoluteRectangle(ownerAbsRect, errW, errH) {
        const scrRect = new Rectangle(0, TOP_WINDOWS_MARGIN, window.innerWidth, window.innerHeight - TOP_WINDOWS_MARGIN - BOTTOM_WINDOWS_MARGIN);
        const errRect = new Rectangle(ownerAbsRect.Left(), ownerAbsRect.Bottom(), errW, errH);
        if (scrRect.ContainsRectangle(errRect)) {
            return errRect;
        }
        let freeSpaceRect = null;
        const bottomFreeSpaceRect = new Rectangle(scrRect.Left(), ownerAbsRect.Bottom(), scrRect.Width, scrRect.Bottom() - ownerAbsRect.Bottom());
        if (bottomFreeSpaceRect.CanFit(errW, errH)) {
            errRect.Y = ownerAbsRect.Bottom();
            freeSpaceRect = bottomFreeSpaceRect;
        }
        else {
            const topFreeSpaceRect = new Rectangle(scrRect.Left(), scrRect.Top(), scrRect.Width, ownerAbsRect.Top() - scrRect.Top());
            if (topFreeSpaceRect.CanFit(errW, errH)) {
                errRect.Y = ownerAbsRect.Top() - errH;
                freeSpaceRect = topFreeSpaceRect;
            }
        }
        if (!isNullOrUndefined(freeSpaceRect)) {
            errRect.X =
                ownerAbsRect.Left() + errW < freeSpaceRect.Right() ? ownerAbsRect.Left() : scrRect.Right() - errW - 1;
        }
        return errRect;
    }
    Hide(owner) {
        if (!this.isShowed) {
            return;
        }
        if (owner !== this.owner) {
            return;
        }
        void this.set({ visible: false });
        this.isShowed = false;
    }
    static PopupErrorHandlerInitialize() {
        const _popupError = new PopupErrorScreen();
        popupErrorHandler.setHandler(_popupError);
        popupErrorHandler.Show = _popupError.Show.bind(_popupError);
        popupErrorHandler.Hide = _popupError.Hide.bind(_popupError);
        popupErrorHandler.set = (key) => {
            void _popupError.set(key);
        };
        // popupErrorHandler.on = _popupError.on;
        // popupErrorHandler.off = _popupError.off;
        popupErrorHandler.isShowed = () => {
            return _popupError.isShowed;
        };
    }
}
Control.extendWith(PopupErrorScreen, {
    // template
    template: TerceraPopupErrorScreen,
    el: '#popupErrorScreenContainer',
    data: function () {
        return {
            visible: false,
            errorText: '',
            headerText: 'Error',
            headerVisible: true,
            width: 140,
            elementStyle: 'js-win-popupError-top',
            additionalStyle: ''
        };
    }
});
